export const translationVI = {
  top: {
    text_1: 'Thực phẩm tươi & hành tinh xanh',
    text_2: 'HÀNG NGÀN',
    text_3: 'CÔNG THỨC NẤU ĂN',
    text_4: 'Nơi giúp bạn quản lý nguyên liệu',
    text_5: 'Công thức từ nhiều nền ẩm thực',
    text_6: 'Thực đơn hàng tuần, danh sách mua sắm',
  },
  main_function: {
    text_1: 'Chức năng chính',
    text_1_1: 'Giữ thực phẩm luôn tươi!',
    text_1_2: 'Nhận thông báo từ bộ kiểm tra độ tươi để tránh lãng phí thực phẩm',
    text_2_1: 'Gợi ý công thức nấu ăn bằng AI',
    text_2_2:
      'Khám phá công thức từ nhiều nền ẩm thực trên thế giới dựa trên các nguyên liệu còn lại trong tủ lạnh của bạn',
    text_3_1: 'Thực đơn cho cả tuần',
    text_3_2: 'Tạo thực đơn cho cả tuần',
    text_4_1: 'Danh sách mua sắm',
    text_4_2: 'Tạo và cập nhật danh sách mua sắm để chuẩn bị cho chuyến đi mua sắm',
    text_5: 'Tải xuống',
    text_6: 'iFridge sẽ giúp bạn',
    text_7_1: 'Trở thành người nội trợ giỏi hơn',
    text_7_2: 'Giảm lãng phí & xây dựng một hành tinh khỏe mạnh hơn',
    text_7_3: 'Thích thú với việc nấu ăn',
  },
  rate_box: {
    text_1: 'Đánh giá từ người dùng',
  },
  faqs: {
    text_1: 'Câu hỏi thường gặp',
    text_2_1: 'Có những loại tài khoản nào? Tôi có thể sử dụng ứng dụng miễn phí không?',
    text_2_2: `Bạn có 1 tháng đầu tiên để sử dụng tất cả các chức năng của ứng dụng miễn phí và không có quảng cáo.
      <br /><br />Sau 1 tháng, tài khoản của bạn sẽ tự động trở thành TÀI KHOẢN MIỄN PHÍ.
      <br /><br />Với TÀI KHOẢN MIỄN PHÍ, bạn có thể sử dụng các chức năng cơ bản như: quản lý nguyên liệu, báo cáo trạng thái nguyên liệu hàng ngày. Bạn sẽ không thể sử dụng các chức năng nâng cao như: gợi ý công thức bằng AI, thực đơn hàng tuần, danh sách mua sắm. Quảng cáo cũng sẽ xuất hiện khi bạn sử dụng ứng dụng.
      <br /><br />Để sử dụng tất cả các chức năng của ứng dụng mà không có quảng cáo, bạn cần nâng cấp lên TÀI KHOẢN PREMIUM với mức phí hàng tháng rất hợp lý.`,
    text_3_1: 'TÀI KHOẢN PREMIUM có giá bao nhiêu?',
    text_3_2: `Bạn có thể đăng ký theo tháng hoặc năm.
      <br /><br />Phí theo tháng: $0,99/tháng.
      <br /><br />Phí theo năm: $9,99/năm.
      <br /><br />Không có phí nào khác.`,
    text_4_1: 'Tôi có thể đăng ký TÀI KHOẢN PREMIUM mà không cần trả phí không?',
    text_4_2: `Bạn hoàn toàn có thể.
      <br /><br />Để đăng ký TÀI KHOẢN PREMIUM, bạn có thể sử dụng Điểm iFridge.
      <br /><br />Điểm iFridge có thể được mua thông qua App Store/Google Play: Tại màn hình Cài đặt, chọn menu Điểm để truy cập màn hình mua Điểm.
      <br /><br />Hoặc bạn có thể kiếm Điểm iFridge bằng cách xem quảng cáo: Tại màn hình Cài đặt, chọn menu Cài đặt khác và chọn Xem quảng cáo.`,
    text_5_1: 'Tôi có nhận được Điểm iFridge khi xem quảng cáo không?',
    text_5_2: `Bạn có thể nhận được Điểm iFridge khi xem quảng cáo.
      <br /><br />Tùy theo quốc gia của bạn, bạn sẽ nhận được một số lượng Điểm iFridge nhất định cho mỗi lần xem quảng cáo (theo quy định của Google Admob). Sau khi xem một quảng cáo, bạn cần chờ 20 phút để có thể xem quảng cáo tiếp theo.`,
    text_6_1: 'Tôi có thể kiếm Điểm iFridge bằng cách giới thiệu bạn bè không?',
    text_6_2: `Bạn hoàn toàn có thể nhận Điểm iFridge thông qua việc giới thiệu bạn bè.
      <br /><br />Tùy thuộc vào quốc gia của bạn, bạn có thể nhận được một lượng Điểm iFridge nhất định khi chia sẻ thông tin về iFridge trên các mạng xã hội như Facebook, Twitter, v.v.
      <br /><br />Trong 1 tháng, bạn chỉ có thể nhận Điểm iFridge một lần thông qua giới thiệu.`,
    text_7_1: 'Dữ liệu cá nhân của tôi có được lưu trữ an toàn không? Có được chia sẻ với bên thứ ba không?',
    text_7_2:
      'Dữ liệu của bạn được lưu trữ hoàn toàn trên điện thoại của bạn và hoàn toàn bảo mật. Chúng tôi không lưu trữ dữ liệu cá nhân của bạn trên máy chủ của chúng tôi, cũng như không chia sẻ dữ liệu cá nhân của bạn với bất kỳ bên thứ ba nào.',
    text_8_1: 'Nếu cần hỗ trợ, tôi nên liên hệ thế nào?',
    text_8_2: `Bạn có thể liên hệ với chúng tôi thông qua chức năng Liên hệ: Tại màn hình Cài đặt, chọn Cài đặt khác và sau đó chọn Liên hệ.
      <br /><br />Hoặc gửi yêu cầu hỗ trợ/phản hồi trực tiếp qua email: ifridge.foodie@gmail.com`,
  },
  footer: {
    text_1: 'Tình yêu có thể đến rồi đi,',
    text_2: 'nhưng cơn đói ghé thăm mỗi ngày',
  },
};
